import { post } from "@libs:axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { omit } from "lodash";
import { CamelCasedPropertiesDeep } from "type-fest";

import {
  SearchApiSearchPostData,
  SearchApiSearchPostResponses,
} from "@:openapi";

export interface Search {
  SEARCH: {
    RequestBody: CamelCasedPropertiesDeep<SearchApiSearchPostData["body"]>;
    RequestQuery: CamelCasedPropertiesDeep<SearchApiSearchPostData["query"]>;
    Response: CamelCasedPropertiesDeep<SearchApiSearchPostResponses["200"]>;
  };
}

export const useMutationSearch = (
  options?: Omit<
    UseMutationOptions<
      Search["SEARCH"]["Response"],
      AxiosError,
      Search["SEARCH"]["RequestBody"] & Search["SEARCH"]["RequestQuery"]
    >,
    "mutationKey"
  >,
) => {
  return useMutation<
    Search["SEARCH"]["Response"],
    AxiosError,
    Search["SEARCH"]["RequestBody"] & Search["SEARCH"]["RequestQuery"]
  >({
    mutationKey: ["search"],
    mutationFn: (data) => {
      return post<Search["SEARCH"]["Response"]>(
        "/api/search/",
        omit(data, "botId"),
        {
          params: {
            botId: data.botId,
          },
        },
      );
    },
    ...options,
  });
};
